import PropTypes from 'prop-types';

const Line = (props) => (
  <div className='record-line'>
    <div className={`line-value  ${props.isExpanded ? '' : 'excerpt'}`}>{props.value}</div>
    <div className='line-label'>{props.label}</div>
  </div>
);

Line.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.any.isRequired,
  isExpanded: PropTypes.bool,
};

Line.defaultProps = {
  isExpanded: false,
};

export default Line;
